import InputErrorMessage from './InputErrorMessage'
export default InputErrorMessage
export type { InputErrorMessage } from './InputErrorMessage'
export { Label } from './InputErrorMessage.styles'
